import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Menu } from '../../Menu';
import { useOverlayPopupZIndex } from '../../OverlayContext';
import { Popover } from '../../Popover';
import { GetTokenPickerTID } from './TokenPicker.testIds';
import { closingFooterItems, toMenuItems } from './TokenPicker.utils';
export function TokenPicker(param) {
    let { config, trigger } = param;
    const { anchorEl, select, dismiss } = trigger;
    const { entries, search, onPicked, testId, popoverTestId, footer } = config, menuProps = _object_without_properties(config, [
        "entries",
        "search",
        "onPicked",
        "testId",
        "popoverTestId",
        "footer"
    ]);
    const zIndex = useOverlayPopupZIndex();
    const { TokenPickerTestIds } = useMemo(()=>GetTokenPickerTID(testId), [
        testId
    ]);
    const items = useMemo(()=>toMenuItems(entries, TokenPickerTestIds, (label)=>{
            select(label);
            onPicked === null || onPicked === void 0 ? void 0 : onPicked({
                label,
                anchorEl,
                isCreation: false
            });
        }), [
        anchorEl,
        entries,
        onPicked,
        select,
        TokenPickerTestIds
    ]);
    const searchProps = useMemo(()=>{
        if (!search) return undefined;
        const { action } = search, rest = _object_without_properties(search, [
            "action"
        ]);
        if (!action) return rest;
        const { onCreate } = action, actionRest = _object_without_properties(action, [
            "onCreate"
        ]);
        const onSubmit = (label)=>{
            onCreate === null || onCreate === void 0 ? void 0 : onCreate(label);
            select(label);
            onPicked === null || onPicked === void 0 ? void 0 : onPicked({
                label,
                anchorEl,
                isCreation: true
            });
        };
        return _object_spread_props(_object_spread({}, rest), {
            action: _object_spread_props(_object_spread({}, actionRest), {
                onSubmit
            })
        });
    }, [
        anchorEl,
        onPicked,
        search,
        select
    ]);
    const closingFooter = useMemo(()=>footer ? _object_spread_props(_object_spread({}, footer), {
            items: closingFooterItems(footer.items, dismiss)
        }) : undefined, [
        dismiss,
        footer
    ]);
    return /*#__PURE__*/ _jsx(Popover, {
        open: !!anchorEl,
        anchorEl: anchorEl,
        onClose: dismiss,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        },
        transformOrigin: {
            vertical: -4,
            horizontal: 'left'
        },
        disableEnforceFocus: true,
        style: {
            zIndex
        },
        testId: popoverTestId !== null && popoverTestId !== void 0 ? popoverTestId : TokenPickerTestIds.Popover(),
        children: /*#__PURE__*/ _jsx(Menu, _object_spread_props(_object_spread({}, menuProps), {
            flat: true,
            items: items,
            searchProps: searchProps,
            footer: closingFooter,
            testId: testId
        }))
    });
}
